import styled, { css } from 'react-emotion';
import theme from '@lyearn-team/theme-config';
import { withTheme } from 'emotion-theming';

export const CompanyPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  align-items: center;
  box-sizing: border-box;
  &.pageWrapper {
    @media (min-width: 767px) {
      padding: 63px 55px 87px;
      width: 503px;
      height: 463px;
    }
    background-color: ${theme.color.dark.saturn};
    padding: 37px 100px 72px;
    @media (max-width: 767px) {
      padding: 80px 16px 20px;
      width: 100%;
      height: 100%;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const GlobalErrorWrapper = styled.div`
  font-size: 14px;
  margin: 10px 0 20px;
  color: ${theme.color.dark.ruby};
  align-self: flex-start;
`;

export const FixWidthColumn = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 394px;
  margin: 68px auto;
  align-items: center;

  @media (max-width: 767px) {
    width: 100%;
    flex-grow: 1;
    justify-content: space-between;
  }
`;

export const PasswordInputDiv = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 394px;
  align-items: center;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const passwordWrapperClass = css`
  margin: 0px 55px 12px;
  width: 100%;
`;

export const confirmPasswordWrapperClass = css`
  margin: 0 55px;
  width: 100%;
`;

export const GlobalMessage = withTheme(styled.div`
  ${({ theme: { color } }) => `
    color: ${color.black3};
    font-size: 14px;
    line-height: 17px;
    margin: 58px 0 0px;
    a {
      cursor: pointer;
      text-decoration: underline;
      color: ${color.black3};
      :hover {
        color: ${color.black2};
      }
    }
  `};
`);

export const inputClass = css`
  padding: 10px 20px;
  width: 100%;
  @media (max-width: 767px) {
    text-align: left;
  }
`;

export const buttonClass = css`
  width: 100%;
  line-height: 16px;
  padding: 10px 16px;

  @media (max-width: 767px) {
    text-align: left;
    width: 100%;
    bottom: 18px;
  }
`;

export const FixMargin = styled.div`
  @media (max-width: 767px) {
    height: 60px;
  }
`;
